import api from 'apis/restaurant-api/api';
import { UiLanguageKey } from 'locale/languages';
import type { MerchantRole } from 'modules/access-control';

import { AccessDescription, Merchant, ItemPricingsUpdatePayload, MerchantDetail } from './types';

export const fetchMerchants = (): Promise<Merchant[]> =>
  api.get('/v1/merchant-admin/merchants').then(response => response.data.results);

export const fetchMerchant = (id: string): Promise<MerchantDetail> =>
  api.get(`/v1/merchant-admin/merchants/${id}`).then(response => response.data.results[0]);

export const updateItemPricing = (merchantId: string, itemId: string, payload: ItemPricingsUpdatePayload) =>
  api.put(`/v1/merchant-admin/merchants/${merchantId}/item-commissions/${itemId}`, payload).then(() => undefined);

export const bulkUpdateItemPricing = (
  merchantId: string,
  payload: { item_id: string; commissions: ItemPricingsUpdatePayload }[],
) =>
  api
    .put(`/v1/merchant-admin/merchants/${merchantId}/item-commissions/bulk-update`, payload)
    .then(response => response.data);

export const fetchMerchantAccess = (merchantId: string) =>
  api
    .get<{ results: AccessDescription[] }>(`/v1/merchant-admin/merchants/${merchantId}/access`)
    .then(response => response.data.results);

export const deleteMerchantAccess = (merchantId: string, userEmail: string, userId: string | undefined) =>
  api.delete(`/v1/merchant-admin/merchants/${merchantId}/access`, {
    data: {
      id: userId,
      email: userEmail,
    },
  });

export const grantTentativeMerchantAccess = (
  merchantId: string,
  email: string,
  role: MerchantRole,
  preferredLocale: UiLanguageKey,
) =>
  api.put(`/v1/merchant-admin/merchants/${merchantId}/access`, {
    email,
    role,
    preferred_locale: preferredLocale,
  });

export const grantMerchantAccess = (merchantId: string, userId: string, role: string) =>
  api.put(`/v1/merchant-admin/merchants/${merchantId}/access`, {
    id: userId,
    role,
  });
